﻿{
  "US": "États-Unis",
  "AF": "Afghanistan",
  "AX": "Îles Aland",
  "AL": "Albanie",
  "DZ": "Algérie",
  "AS": "Samoa américaines",
  "AD": "Andorre",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctique",
  "AG": "Antigua-et-Barbuda",
  "AR": "Argentine",
  "AM": "Arménie",
  "AW": "Aruba",
  "AU": "Australie",
  "AT": "Autriche",
  "AZ": "Azerbaïdjan",
  "BS": "Bahamas",
  "BH": "Bahreïn",
  "BD": "Bangladesh",
  "BB": "Barbade",
  "BY": "Biélorussie",
  "BE": "Belgique",
  "BZ": "Bélize",
  "BJ": "Bénin",
  "BM": "Bermudes",
  "BT": "Bhoutan",
  "BO": "Bolivie",
  "BA": "Bosnie Herzégovine",
  "BW": "Botswana",
  "BV": "Île Bouvet",
  "BR": "Brésil",
  "IO": "Territoire britannique de l'océan Indien",
  "BN": "Brunei Darussalam",
  "BG": "Bulgarie",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambodge",
  "CM": "Cameroun",
  "CA": "Canada",
  "CV": "Cap-Vert",
  "KY": "Îles Caïmans",
  "CF": "République centrafricaine",
  "TD": "Tchad",
  "CL": "Chili",
  "CN": "Chine",
  "CX": "Île Christmas",
  "CC": "Îles Cocos (Keeling)",
  "CO": "Colombie",
  "KM": "Comores",
  "CG": "Congo",
  "CD": "République démocratique du Congo",
  "CK": "Îles Cook",
  "CR": "Costa Rica",
  "CI": "Côte d'ivoire",
  "HR": "Croatie",
  "CU": "Cuba",
  "CY": "Chypre",
  "CZ": "République Tchèque",
  "DK": "Danemark",
  "DJ": "Djibouti",
  "DM": "Dominique",
  "DO": "République Dominicaine",
  "EC": "Équateur",
  "EG": "Égypte",
  "SV": "Salvador",
  "GQ": "Guinée Équatoriale",
  "ER": "Érythrée",
  "EE": "Estonie",
  "ET": "Éthiopie",
  "FK": "îles Falkland (Malouines)",
  "FO": "Îles Féroé",
  "FJ": "Fidji",
  "FI": "Finlande",
  "FR": "France",
  "GF": "Guyane française",
  "PF": "Polynésie française",
  "TF": "Terres australes françaises",
  "GA": "Gabon",
  "GM": "Gambie",
  "GE": "Géorgie",
  "DE": "Allemagne",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grèce",
  "GL": "Groenland",
  "GD": "Grenade",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernesey",
  "GN": "Guinée",
  "GW": "Guinée-Bissau",
  "GY": "Guyane",
  "HT": "Haïti",
  "HM": "Îles Heard-et-MacDonald",
  "VA": "Saint-Siège (État de la cité du Vatican)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hongrie",
  "IS": "Islande",
  "IN": "Inde",
  "ID": "Indonésie",
  "IR": "Iran, République islamique d'",
  "IQ": "Irak",
  "IE": "Irlande",
  "IM": "Île de Man",
  "IL": "Israël",
  "IT": "Italie",
  "JM": "Jamaïque",
  "JP": "Japon",
  "JE": "Jersey",
  "JO": "Jordanie",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KR": "Corée",
  "KW": "Koweït",
  "KG": "Kirghizistan",
  "LA": "Laos, République démocratique populaire du",
  "LV": "Lettonie",
  "LB": "Liban",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Jamahiriya arabe libyenne",
  "LI": "Liechtenstein",
  "LT": "Lituanie",
  "LU": "Luxembourg",
  "MO": "Macau",
  "MK": "Macédoine",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaisie",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malte",
  "MH": "Îles Marshall",
  "MQ": "Martinique",
  "MR": "Mauritanie",
  "MU": "Île Maurice",
  "YT": "Mayotte",
  "MX": "Mexique",
  "FM": "Micronésie, États fédérés de",
  "MD": "Moldavie",
  "MC": "Monaco",
  "MN": "Mongolie",
  "ME": "Monténégro",
  "MS": "Montserrat",
  "MA": "Maroc",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibie",
  "NR": "Nauru",
  "NP": "Népal",
  "NL": "Pays-Bas",
  "AN": "Antilles néerlandaises",
  "NC": "Nouvelle Calédonie",
  "NZ": "Nouvelle Zélande",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niué",
  "NF": "Île Norfolk",
  "MP": "Îles Mariannes du Nord",
  "NO": "Norvège",
  "OM": "Norvège",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Territoires palestiniens, occupés",
  "PA": "Panama",
  "PG": "Papouasie-Nouvelle-Guinée",
  "PY": "Paraguay",
  "PE": "Pérou",
  "PH": "Philippines",
  "PN": "Pitcairn",
  "PL": "Pologne",
  "PT": "Portugal",
  "PR": "Porto Rico",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Roumanie",
  "RU": "Fédération de Russie",
  "RW": "Rwanda",
  "BL": "Saint Barthélemy",
  "SH": "Sainte-Hélène",
  "KN": "Saint-Christophe-et-Niévès",
  "LC": "Sainte-Lucie",
  "MF": "Saint Martin",
  "PM": "Saint-Pierre-et-Miquelon",
  "VC": "Saint-Vincent-et-les-Grenadines",
  "WS": "Samoa",
  "SM": "Saint-Marin",
  "ST": "Sao Tomé-et-Principe",
  "SA": "Arabie Saoudite",
  "SN": "Sénégal",
  "RS": "Serbie",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapour",
  "SK": "Slovaquie",
  "SI": "Slovénie",
  "SB": "Îles Salomon",
  "SO": "Somalie",
  "ZA": "Afrique du sud",
  "GS": "Géorgie du sud et îles Sandwich",
  "ES": "Espagne",
  "LK": "Sri Lanka",
  "SD": "Soudan",
  "SR": "Surinam",
  "SJ": "Svalbard et Jan Mayen",
  "SZ": "Swaziland",
  "SE": "Suède",
  "CH": "Suisse",
  "SY": "République arabe syrienne",
  "TW": "Taïwan",
  "TJ": "Tadjikistan",
  "TZ": "Tanzanie",
  "TH": "Thaïlande",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokélaou",
  "TO": "Tonga",
  "TT": "Trinité-et-Tobago",
  "TN": "Tunisie",
  "TR": "Turquie",
  "TM": "Turkménistan",
  "TC": " Îles Turques et Caïques",
  "TV": "Tuvalu",
  "UG": "Ouganda",
  "UA": "Ukraine",
  "AE": "Émirats arabes unis",
  "GB": "Royaume-Uni",
  "UM": "Îles Éloignées Des États-Unis ",
  "UY": "Uruguay",
  "UZ": "Ouzbékistan",
  "VU": "Vanuatu",
  "VE": "Vénézuela",
  "VN": "Vietnam",
  "VG": "Îles Vierges britanniques",
  "VI": "Îles Vierges américaines",
  "WF": "Wallis et Futuna",
  "EH": "Sahara occidental",
  "YE": "Yémen",
  "ZM": "Zambie",
  "ZW": "Zimbabwe"
}
